import { protectedAxiosInstance } from 'helpers/api-calls';
import { getLocationCode } from '../cookies';

/**
 * Generates planned shifts for a location
 * @param {Object} config - The schedule generation configuration
 * @param {boolean} config.unpublish - Whether to unpublish existing shifts
 * @param {number} config.min_length - Minimum shift length in minutes
 * @param {number} config.max_length - Maximum shift length in minutes
 * @param {Object} config.hours_of_operation - Hours of operation for each day
 * @param {string} config.start_date - Start date in YYYY-MM-DD format
 * @param {string} config.end_date - End date in YYYY-MM-DD format
 * @param {number} config.min_schedule_hours_per_week - Minimum schedule hours per week
 * @param {number} config.overtime_threshold - Overtime threshold in hours
 * @returns {Promise} - The API response
 */
export const generatePlannedShifts = (config) => {
  const locationId = getLocationCode('location_id');

  return protectedAxiosInstance.request({
    url: `/api/customer/user_role/locations/${locationId}/generate_week_planned_shifts`,
    method: 'PUT',
    data: {
      async_mode: true,
      unpublish: config.unpublish,
      min_length: config.min_length,
      max_length: config.max_length,
      hours_of_operation: config.hours_of_operation,
      start_date: config.start_date,
      end_date: config.end_date,
      min_schedule_hours_per_week: config.min_schedule_hours_per_week,
      overtime_threshold: config.overtime_threshold,
      minimum_break_minutes: config.minimum_break_minutes,
      availability_fulfill_level: config.availability_fulfill_level,
      use_open_shifts: config.use_open_shifts
    }
  });
};

/**
 * Checks the status of a schedule generation job by UUID
 * @param {string} uuid - The job UUID returned by generatePlannedShifts
 * @returns {Promise} - The API response with job status (finished_at, status, etc.)
 */
export const getJobStatus = (uuid) => {
  return protectedAxiosInstance.request({
    url: `/api/customer/user_role/action_jobs/${uuid}`,
    method: 'GET',
  });
}; 